import React, { Component } from 'react';
import {
  Tooltip,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Typography,
  IconButton,
  Box,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MenuListItem from './MenuListItem';
import List from '@mui/material/List';
import Collapse from '@mui/material/Collapse';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons';

class ExpandableMenuListItem extends Component {
  onToggleAccordion = (e) => {
    e.stopPropagation();
    if (this.props.onToggleAccordion) {
      this.props.onToggleAccordion();
    }
  };

  onClickTitle = (e) => {
    e.stopPropagation();
    if (this.props.onClickTitle) {
      this.props.onClickTitle();
    }
  };

  render() {
    const isOpen = this.props.isMenuItemOpen;
    const accessibleName = this.props.ariaLabel || this.props.title;

    return (
      <React.Fragment>
        <ListItem
          disableGutters
          sx={{ p: 0, pl: '4px', display: 'block' }}
          className="expandableMenuItem"
        >
          <Box
            sx={{ display: 'flex', alignItems: 'center' }}
            className="expandableMenuItem__header"
          >
            <ListItemButton
              id={'sideNav__button_' + this.props.title.replace(' ', '')}
              onClick={this.onClickTitle}
              aria-label={accessibleName}
              aria-expanded={isOpen}
              className={this.props.isOpen ? 'justify-content-start' : 'justify-content-center'}
              sx={{ flex: 1 }}
            >
              {!this.props.isSideNavOpen && (
                <>
                  <Tooltip title={this.props.title} placement="right" arrow>
                    <ListItemIcon
                      sx={{
                        color: '#DADADA',
                        minWidth: '1.75rem',
                        pt: 1,
                        pb: 1,
                      }}
                      role="button"
                    >
                      <FontAwesomeIcon icon={this.props.icon} size={'lg'} fixedWidth />
                    </ListItemIcon>
                  </Tooltip>
                </>
              )}

              {this.props.isSideNavOpen && (
                <>
                  <ListItemIcon sx={{ color: '#DADADA', minWidth: '1.75rem' }}>
                    <FontAwesomeIcon icon={this.props.icon} size={'lg'} fixedWidth />
                  </ListItemIcon>
                  <ListItemText
                    disableTypography
                    sx={{
                      opacity: this.props.isSideNavOpen ? 1 : 0,
                    }}
                    primary={
                      <Typography
                        sx={{
                          mr: 1,
                          fontWeight: '600',
                          color: 'white',
                        }}
                      >
                        {this.props.title}
                      </Typography>
                    }
                  />
                </>
              )}
            </ListItemButton>

            <Tooltip
              title={isOpen ? 'Collapse ' + accessibleName : 'Expand ' + accessibleName}
              placement="right"
              arrow
            >
              <IconButton
                id={'sideNav__chevron_' + this.props.title.replace(' ', '')}
                onClick={this.onToggleAccordion}
                aria-label={isOpen ? 'Collapse ' + accessibleName : 'Expand ' + accessibleName}
                aria-expanded={isOpen}
                sx={{ color: '#DADADA', mr: 1 }}
                size="small"
              >
                <FontAwesomeIcon
                  icon={isOpen ? faChevronUp : faChevronDown}
                  size={'xs'}
                  fixedWidth
                />
              </IconButton>
            </Tooltip>
          </Box>

          <Collapse in={isOpen} timeout="auto" unmountOnExit>
            <List sx={{ ml: 0 }} component="ul" disablePadding className="expandableMenuItem__list">
              {this.props.expandableItems.map((item) => {
                return (
                  (item.isVisible ?? true) && (
                    <MenuListItem
                      key={item.title}
                      title={item.title}
                      isOpen={this.props.isSideNavOpen}
                      img={item.img}
                      icon={item.icon}
                      isNewWindow="true"
                      onClick={() => {
                        if (item.url) {
                          window.open(item.url, '_blank');
                        } else {
                          item.onClick();
                        }
                      }}
                    />
                  )
                );
              })}
            </List>
          </Collapse>
        </ListItem>
      </React.Fragment>
    );
  }
}

export default ExpandableMenuListItem;
